import { useEffect } from "react";
import { handleError } from "../../services/serviceBase";

const useStreamState = ({ detailsHeader, idReturnFileHead, user, setState, intl }) => {
  useEffect(() => {
    if (detailsHeader !== null) {
      const fetchState = async () => {
        const response = await fetch(
          process.env.REACT_APP_BASE_URL +
            "returnfiles/" +
            idReturnFileHead +
            "/streamState",
          {
            headers: {
              Accept: "text/event-stream",
              Authorization: `Bearer ${user.access_token}`,
            },
          }
        );

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          const chunk = decoder.decode(value);
          const lines = chunk.split("\n");

          for (const line of lines) {
            if (line.startsWith("data: ")) {
              const data = line.slice(6);
              if (data.trim()) {
                try {
                  const parsed = JSON.parse(data);
                  if (detailsHeader.rfStateCode !== parsed.RFStateCode) {
                    setState({
                      rfState: parsed.RFStateDescr,
                      rfStateCode: parsed.RFStateCode,
                    });
                  }
                } catch (e) {
                  console.error("Errore parsing JSON:", e);
                }
              }
            }
          }
        }
      };

      fetchState().catch((error) => {
        handleError(error, intl);
      });
    }
  }, [detailsHeader]);
};

export default useStreamState;